import { render, staticRenderFns } from "./contentBox.vue?vue&type=template&id=2c0ca62c&scoped=true&"
import script from "./contentBox.vue?vue&type=script&lang=js&"
export * from "./contentBox.vue?vue&type=script&lang=js&"
import style0 from "./contentBox.vue?vue&type=style&index=0&id=2c0ca62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ca62c",
  null
  
)

export default component.exports